// extracted by mini-css-extract-plugin
module.exports = {"chart":"DoughnutChart_chart__3I394","wrap":"DoughnutChart_wrap__1Qxvz","chartNumber":"DoughnutChart_chartNumber__3fYtc"};